<template>
  <div
    class="info-header flex-col mb-3 gap-3 md:flex-row md:divide-x md:*:pl-3"
  >
    <div class="!pl-0" data-cy="status-container">
      <b data-cy="status-label">Status</b>
      <div data-cy="status-value">{{ status }}</div>
    </div>

    <div data-cy="schedule-container">
      <b data-cy="schedule-label">Scheduled for</b>
      <div data-cy="schedule-value">{{ scheduledLabel }}</div>
    </div>
    <div data-cy="duration-container">
      <b data-cy="duration-label">Estimated Duration</b>
      <div data-cy="duration-value">
        <minutes-label
          :minutes="appointment.estimated_duration_minutes"
          data-cy="minutes-label"
        ></minutes-label>
      </div>
    </div>
    <div>
      <b
        ><i v-if="appointment.customer_scheduled" class="fas fa-user mr-1"></i
        >{{ createdText }}</b
      >
      <div>{{ formatTime(appointment.created_time) || "--" }}</div>
      <div v-if="appointment.created_by">
        <b>{{ userTypeLabel }}:</b>
        <a :href="redirectToCreatedBy">
          {{ appointment.created_by.full_name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Divider from "@/components/Divider.vue";
import MinutesLabel from "@/components/MinutesLabel.vue";
import CONSTANTS from "@/Constants.js";
import { capitalize } from "@/mixins";

export default {
  components: {
    Divider,
    MinutesLabel
  },
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    createdText() {
      return `Created by ${
        this.appointment.customer_scheduled ? "Customer" : "Staff"
      }`;
    },
    status() {
      return CONSTANTS.APPOINTMENT_STATUS_MAP[this.appointment.status];
    },
    userTypeLabel() {
      return capitalize(this.appointment.created_by.user_type);
    },
    redirectToCreatedBy() {
      return this.polymorphicUserPath({
        id: this.appointment.created_by.id,
        type: this.appointment.created_by.user_type
      });
    },
    scheduledLabel() {
      return this.scheduledDateTime(
        this.appointment.scheduled_time,
        this.appointment.arrival_window_start,
        this.appointment.arrival_window_end
      );
    }
  },
  methods: {
    formatTime(time) {
      if (!time) {
        return "--";
      }
      return this.formatDateTimeWithTimezone(
        time,
        this.appointment.address.time_zone
      );
    },
    toggleModal(modal) {
      this[modal] = !this[modal];
    }
  }
};
</script>

<style lang="scss" scoped>
.info-header {
  display: flex;
}
</style>
